import { styled } from '../theme';
import Text from './Text';

const H5 = styled(Text.withComponent('h5'))(({ theme }) => ({
    fontWeight: theme.typography.fontWeight.medium,
    fontSize: '1.8rem',
}));

export default H5;
